<template>
    <div>
         <div>
            <div v-for="(item,i) of li" :key="i" @click="fun(item.id,i)" >
             <div class="li" :class="active==i?'activeli':''">
                <router-link :to="item.href?item.href:'#'">{{item.name}}</router-link>
             </div>
           </div>
         </div>

         <div class="lian">
                   <div>联系我们</div>
                    <pre>
       
       联系人：韩先生
                      
       手机号：13366936909

       电  话：010-56268817

       传  真：010-89351791

       地  址：北京房山区天星街
              1号院14号楼1206
                </pre>
        </div>
     </div> 
</template>
<script>
export default {
    data(){
        return{
        active:9999,
        id:'',
      
        li:[]
        }
    },
    methods:{
        all(){
              this.axios.get('/nType/all').then((res)=>{
                  this.li=res.data
                  
                  });
        },
        fun(id,i){
         let id1=document.getElementById(id)
         if(id1){
           id1.scrollIntoView()
         }
      }
    },
    created(){
        this.all()
    }
}
</script>
<style scoped>
 .li{
  /* transition: .8s linear; */
  height: 55px;
  font-size: 14px;
  line-height: 55px;
  box-sizing: border-box;
  cursor: pointer;
   background: #f8f5f5;
   position: relative;
   text-align: center;
 }
.li:hover{
    background:#EB5356;
    color: white;
}
.li:hover a{
    color: white;
}
.activeli{
    background: red;
    color: white;
}
.activeli .sanjiao{
    border-left: 10px solid #fff;
}
.li:hover .sanjiao{
    border-left: 10px solid #fff;
}
.sanjiao{
    position: absolute;
    width: 0;
    height: 0;
    left: 25px;
    top: 16px;
    border-top: 5px solid transparent;
    border-left: 10px solid red;
    border-bottom: 5px solid transparent;
}
.lian{
    margin-top:30px;
    background: #f8f5f5;
    font-size:13px;
}
.lian>div{
    font-size: 16px;
     text-align: center;
     padding: 20px 0;
     background:rgba(224,224,224,1);
     border-radius:5px 5px 0px 0px;
 }
.lian>pre{
    margin-top: 2px;
    font-size: 14px;
    color: #221815;
}
</style>